////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { map, isUndefined, isArray, orderBy } from 'lodash'
///////COMPONENTS///////
import Tooltip from '../../../Tooltip/Tooltip'
import theme from '../../../../theme/theme'
/////////ASSETS/////////
import dot from '../../../../assets/icones/global/dot-three.svg'

/////////STYLED/////////
const ActionsTableWrapper = styled.div`
	display: flex;
	justify-content: space-around;
	position: ${(props) => (props.notInNested ? 'relative' : 'initial')};
`
const ActionsTableButtonWrapper = styled.div`
	cursor: ${(props) => (!props.disabled ? 'pointer' : 'default')};
	background-color: ${(props) => (!props.disabled ? props.theme.colors.primary : theme.colors.grey)};
	height: 32px;
	width: 32px;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	:hover {
		background-color: ${(props) => (!props.disabled ? props.theme.colors.hoverPrimary : theme.colors.grey)};
	}
	transition: background-image 0.1s;
	margin-left: 1%;
`
const ActionsTableButton = styled.img``

const ActionsList = styled.div`
	position: absolute;
	display: ${(props) => (props.showPaper ? 'grid' : 'none')};
	z-index: 100;
	grid-template-columns: max-content;
	/*grid-auto-rows: 40px;*/
	justify-content: stretch;
	align-items: stretch;
	background-color: ${(props) => props.theme.colors.white};
	box-shadow: 0 0px 6px rgba(0, 0, 0, 0.16);
	padding: 10px 20px;

	top: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return '-30%'

			case parseInt(props.dataSize) - 1:
				return 'unset'

			default:
				return '62%'
		}
	}};
	bottom: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return 'unset'

			case parseInt(props.dataSize) - 1:
				return '0%'

			default:
				return 'unset'
		}
	}};
	right: ${(props) => (props.notInNested ? '55px' : '-50px')};
	transform: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return props.isWithActionIcons ? 'translateX(-5%)' : 'translateX(-50%)'

			case parseInt(props.dataSize) - 1:
				return props.isWithActionIcons ? 'translateX(-5%)' : 'translateX(-50%)'

			default:
				return props.isWithActionIcons ? 'translateX(-5%) translateY(-57%)' : 'translateX(-50%) translateY(-50%)'
		}
	}};
	z-index: 11;
	background-color: white;
	overflow: hidden;
	& > div {
		line-height: 32px;
		text-align: left;
		cursor: pointer;
		box-sizing: content-box;
	}
`
const ActionsItem = styled.div`
	display: ${(props) => (props.isVisible ? 'initial' : 'none')};
`
/////////STYLED/////////

const ActionsTable = (props) => {
	const [alphaSortTable, setAlphaSortTable] = useState()

	const { translations, columns } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			columns: state.columns.isEditingTrigger,
		}),
		shallowEqual
	)
	// we use this effect to display an alphabetical sorted action list
	// to prevent case conflict we convert on uppercase all string to display
	useEffect(() => {
		setAlphaSortTable(orderBy(props.actionsList, (e) => !isUndefined(e.name) && e.name.toUpperCase(), ['asc', 'desc']))
	}, [props.actionsList])

	///////////////////////////////// RENDER ///////////////////////////////////////
	return (
		<>
			<ActionsTableWrapper notInNested={props.notInNested}>
				{isArray(props.actionsList) &&
				// Load tooltip config if passed in props
				props.tooltipConfig ? (
					// to disabled 3 dot in case of mass edit we need to use isEditingTrigger state and test bool value
					!columns ? (
						<Tooltip
							tooltipId={props.tooltipConfig.tooltipId}
							translationsKey={props.tooltipConfig.translationsKey}
							position={props.tooltipConfig.position}
						>
							<ActionsTableButtonWrapper
								onClick={() => {
									props.handlePaper() /*setShowPaper(!showPaper)*/
								}}
								ref={props.hasRef}
							>
								<ActionsTableButton src={dot} />
							</ActionsTableButtonWrapper>
						</Tooltip>
					) : (
						<ActionsTableButtonWrapper disabled={columns}>
							<ActionsTableButton src={dot} />
						</ActionsTableButtonWrapper>
					)
				) : (
					<ActionsTableButtonWrapper
						onClick={() => {
							props.handlePaper() /*setShowPaper(!showPaper)*/
						}}
						ref={props.hasRef}
					>
						<ActionsTableButton src={dot} />
					</ActionsTableButtonWrapper>
				)}

				<ActionsList
					showPaper={props.stateShowPaper}
					indexRow={props.indexRow} // Index of row where this component is present
					dataSize={props.dataSize} // Size of data, to see if current row is first or last one for example
					notInNested={props.notInNested}
					isWithActionIcons={props.isWithActionIcons}
				>
					{map(alphaSortTable, (elem) => {
						const visible = !isUndefined(elem.isVisible) ? elem.isVisible(props.row) : true
						return (
							<ActionsItem isVisible={visible} onClick={() => elem.clickAction(props.row)}>
								{elem.name}
							</ActionsItem>
						)
					})}
				</ActionsList>
			</ActionsTableWrapper>
		</>
	)
}
ActionsTable.propTypes = {}

ActionsTable.defaultPropTypes = {}

export default ActionsTable
